import React, {useEffect, useState} from "react";
import {
    Typography,
    Grid,
    Card,
    CardContent,
    IconButton, Box, Divider,
} from "@mui/material";
import {Cargo} from "~/apps/packages/warehouse-closure/queries";
import {Add, ChevronRight} from "@mui/icons-material";
import {CargoSelectDialog} from "./CargoSelectDialog/CargoSelectDialog";
import {CardButton} from "~/apps/core/ui/CardButton";
import {useBooleanHistoryState} from "~/apps/core/utils";
import {Close} from "~/ui/icons";
import moment from "moment";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";
import {Tag} from "~/apps/core/ui/Tag";
import {humanizeCargoTag} from "~/apps/packages/warehouse-closure/utils";
import {ConfirmActionDialog} from "~/components/ConfirmActionDialog";


type Value = Cargo;


export type EditableCargoListProps = {
    onChange?: (cargos: Value[]) => any
    value?: Value[]
    disabled?: boolean
}

export const EditableCargoList = (props: EditableCargoListProps) => {
    const [openSelectCargoDialog, setOpenSelectCargoDialog] = useBooleanHistoryState("openSelectCargo");
    const {onChange, value, disabled} = props;
    const [cargoToConfirmRemove, setCargoToConfirmRemove] = useState<string>(null);

    // закрываем диалог при обновлении страницы
    useEffect(() => {
        if (openSelectCargoDialog) {
            setOpenSelectCargoDialog(false);
        }
    }, [])

    const handleOpenSelectDialogClick = () => {
        setOpenSelectCargoDialog(true).then(() => null);
    }

    const handleSelectDialogClose = () => {
        setOpenSelectCargoDialog(false).then(() => null);
    }

    const handleRemoveItemClick = (item: Value) => {
        setCargoToConfirmRemove(item.id)
    }

    const handleCargoSelectDialogChange = (cargos: Value[]) => {
        setOpenSelectCargoDialog(false).then(() => {
            onChange && onChange(cargos);
        });
    }

    const handleConfirmRemoveCargo = () => {
        onChange && onChange(value.filter(cargo => cargo.id != cargoToConfirmRemove));
        setCargoToConfirmRemove(null);
    }

    return (
        <div>
            <ConfirmActionDialog
                open={cargoToConfirmRemove !== null}
                dialogId={"removeCargo"}
                dialogTitle="Вы хотите удалить груз?"
                confirmButtonText="Подтвердить"
                onClose={() => setCargoToConfirmRemove(null)}
                onConfirm={handleConfirmRemoveCargo}
            >
                <Typography width="100%" align="center" variant="screenText">Вы хотите удалить груз?</Typography>
            </ConfirmActionDialog>
            <Grid container direction="column" wrap="nowrap" spacing={1}>
                {value?.map(cargo => (
                    <React.Fragment key={cargo.id}>
                        <Grid item>
                            <Card>
                                <CardContent>
                                    <Grid container direction="column" rowSpacing="8px">
                                        <Grid item container justifyContent="space-between"
                                              alignItems="flex-start"
                                              wrap="nowrap">
                                            <Grid item>
                                                <Box paddingBottom="8px">
                                                    <Typography variant="cardTitle1">
                                                        {cargo.container?.number || cargo.label || "Груз без маркировки"}
                                                    </Typography>
                                                    {cargo.container && (
                                                        <BorderedBox marginLeft="8px" variant="cardText">
                                                            {cargo.container.type}
                                                        </BorderedBox>
                                                    )}
                                                </Box>
                                                <Typography variant="tagsText" display="block" component="div" color="secondary">
                                                    {cargo.description}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <IconButton
                                                    onClick={() => handleRemoveItemClick(cargo)}
                                                    disabled={disabled}
                                                    size="mini"
                                                >
                                                    <Close/>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Grid container spacing="8px">
                                                {Object.entries(cargo.tags || {}).filter(([key, value]) => value).map(([key, value]) => (
                                                    <Grid item key={key}>
                                                        <Tag>
                                                            {humanizeCargoTag(key as any)}
                                                        </Tag>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Divider/>
                                        </Grid>
                                        <Grid item>
                                            <TypographyWithLabel label={cargo.arrival.document.type} noWrap={false}>
                                                {cargo.arrival?.document?.number} от {moment(cargo.arrival.document.date).format("DD MMM YYYY")}
                                            </TypographyWithLabel>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </React.Fragment>
                ))}
                <Grid item>
                    <CardButton
                        startIcon={<Add/>}
                        endIcon={<ChevronRight/>}
                        onClick={handleOpenSelectDialogClick}
                        fullWidth
                        size="large"
                        disabled={disabled}
                    >
                        Добавить груз
                    </CardButton>
                </Grid>
            </Grid>
            <CargoSelectDialog
                open={openSelectCargoDialog}
                onClose={handleSelectDialogClose}
                onChange={handleCargoSelectDialogChange}
                value={value}
            />
        </div>
    );
}
